import { ActionType } from 'typesafe-actions';

import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import * as actions from '../actions/headerActions';
import { HeaderActionsEnum } from '../enums/HeaderActionsEnum';

export type HeaderAction = ActionType<typeof actions>;

export interface IHeaderState {
  isSticked: boolean;
  dirtyResultDecisionGuid?: string;
  dirtyActGriud?: string;
  dirtyAgreementGriud?: string;
  initHash?: string;
}

const initialState: IHeaderState = {
  isSticked: false,
};

export function headerReducer(state: IHeaderState = initialState, action: HeaderAction) {
  switch (action.type) {
    case HeaderActionsEnum.SET_IS_STICKED: {
      return {
        ...state,
        isSticked: action.payload.isSticked,
      };
    }
    case HeaderActionsEnum.SET_IS_DIRTY_RESULT_DECISION: {
      return {
        ...state,
        dirtyResultDecisionGuid: action.payload.dirtyResultDecisionGuid,
      };
    }
    case HeaderActionsEnum.SET_IS_DIRTY_ACT: {
      return {
        ...state,
        dirtyActGriud: action.payload.dirtyActGriud,
      };
    }
    case HeaderActionsEnum.SET_IS_DIRTY_AGREEMENT: {
      return {
        ...state,
        dirtyAgreementGriud: action.payload.dirtyAgreementGriud,
      };
    }
    case HeaderActionsEnum.SET_INIT_HASH: {
      return {
        ...state,
        initHash: action.payload.hash,
      };
    }
    default:
      return state;
  }
}

export const getIsSticked = (state: IRootState) => state.header.isSticked;
export const getDirtyResultDecisionGuid = (state: IRootState) => state.header.dirtyResultDecisionGuid;
export const getDirtyActGuid = (state: IRootState) => state.header.dirtyActGriud;
export const getDirtyAgreementGuid = (state: IRootState) => state.header.dirtyAgreementGriud;
export const getInitHash = (state: IRootState) => state.header.initHash;
